module.exports = __webpack_public_path__ + "static/HeaderImage-c4f72f7db300c447001f2187c390e3d7.png";